// ************************
// // src/app/agendexCliente/components/Login/autologout.js
// autor: W de Paula/IA 
// data: 3/7/24 : 13h47
// objetivo: fazer logof automático da aplicação, apóx X minutos de inatividade
// data: 30/12/24 | 12h57 | eliminamos o localStorage.clear e individualizamos a remoção de componentes
// *********************

// autologout.js

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Defina o tempo de inatividade em milissegundos (por exemplo, 5 minutos)
const INACTIVITY_TIME = 15 * 60 * 1000; // 15 minutos

const AutoLogout = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const events = ['load', 'mousemove', 'mousedown', 'click', 'scroll', 'keypress'];

        const resetTimeout = () => {
            // console.log('Timeout resetado');
            clearTimeout(timeout);
            timeout = setTimeout(logout, INACTIVITY_TIME); // Use a constante aqui
        };

        const logout = () => {
            // console.log('Logout iniciado timeout encerrado');
            // localStorage.clear();
            events.forEach(event => window.removeEventListener(event, resetTimeout));

            const userType = localStorage.getItem('userType'); // Recupera o tipo de usuário
            if (userType === '0') {
                navigate('/app/login/cliente'); // Redireciona para a página do cliente
            } else if (userType === '1') {
                navigate('/app/login/prestador'); // Redireciona para a página do prestador
            } else {
                navigate('/app/login'); // Redireciona para uma página genérica se não houver tipo
            }

            // localStorage.clear(); individualizamos a remoção de itens 30/12/24w
            localStorage.removeItem("tokenlg");
            localStorage.removeItem("tokenacw"); // acrescentado pra independentemente de existir, remover.
            localStorage.removeItem("tokenapw"); // acrescentado pra independentemente de existir, remover.
            localStorage.removeItem("tokenasw");
    
            localStorage.setItem('logoutMessage', 'Você foi desconectado por inatividade.');
            
            // navigate('/app/login/');
        };

        let timeout = setTimeout(logout, INACTIVITY_TIME); // Use a constante aqui
        // console.log('Timeout configurado');

        events.forEach(event => window.addEventListener(event, resetTimeout));

        return () => {
            clearTimeout(timeout);
            events.forEach(event => window.removeEventListener(event, resetTimeout));
        };
    }, [navigate]);

    return null;
};

export default AutoLogout;